import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './Privilege.scss';
import Image from '@max/leez-image';
function Privilege(props) {
    return <View className="comprehensive-card-privilege-container">
      
      <Image className="comprehensive-card-privilege-label" source={{
        uri: props.label
    }} style={{
        width: "30rpx"
    }}/>
      <Text className="comprehensive-card-privilege-desc" numberOfLines={1}>
        {props.desc}
      </Text>
    </View>;
}
export default memo(Privilege);
